import { configureStore } from '@reduxjs/toolkit'
import { authSlice } from '../auth/Auth.slice'
import { profileSlice } from '../profile/Profile.slice'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { apiSlice } from './Api'
import { clientSlice } from '../client/Client.slice'
import { organizationSlice } from '../organization/Organization.slice'
import { assetSlice } from '../asset/Asset.slice'
import { reportSlice } from '../report/Report.slice'
import { reportMetadataSlice } from '../report-metadata/ReportMetadata.slice'
import { contractSlice } from '../contract/Contract.slice'
import { mediaSlice } from '../media/Media.slice'
import { contactSlice } from '../contact/Contact.slice'
import { userSlice } from '../user/User.slice'
import { ticketSlice } from '../helpdesk/ticket/Ticket.slice'
import { taskSlice } from '../helpdesk/task/Task.slice'

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    assetReducer: assetSlice.reducer,
    authReducer: authSlice.reducer,
    clientReducer: clientSlice.reducer,
    contactReducer: contactSlice.reducer,
    contractReducer: contractSlice.reducer,
    ticketReducer: ticketSlice.reducer,
    taskReducer: taskSlice.reducer,
    mediaApi: mediaSlice.reducer,
    organizationReducer: organizationSlice.reducer,
    profileReducer: profileSlice.reducer,
    reportReducer: reportSlice.reducer,
    reportMetadataReducer: reportMetadataSlice.reducer,
    userReducer: userSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiSlice.middleware
      // refreshMiddleware
    ),
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
